module.exports = __webpack_public_path__ + "static/media/CTLA_11-383w.7210d29d.webp";